var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex position-relative"},_vm._l((_vm.questions),function(question,key){return _c('v-chip',{key:key,staticClass:"w-100 py-1 pointer-on-hover border-0",class:{
      'mr-1' : key<_vm.questions.length - 1
    },staticStyle:{"height":"10px"},attrs:{"x-small":"","color":_vm.activeTab !== key ? 'default' : 'active'},on:{"click":function($event){return _vm.$emit('input',key)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }